<template>
    <div v-if="locationName" 
        class="calendar-item-location"
        :class="{'calendar-item-location-url': hasUrl}"
    >
        <span v-html="locationName"></span>
    </div>
</template>
<script>
import {isAppointment} from '@/utils/Filter';
import {meetingPointName} from '@/utils/Item';

export default {
    name: 'CalendarItemLocation',
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    computed: {
        locationName() {
            // Don't make a clickable location - this entire CalendarItem has to be clickable instead.
            if (isAppointment(this.item)) {
                return this.item.location ?? '';
            } else {
                return meetingPointName(this.item, '<i>Pending</i>');
            }   
        },
        hasUrl() {
            return this.locationName.toLowerCase().indexOf('http') !== -1;
        },
    },
}
</script>
<style>

</style>